import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { MediaType } from '../media-constant';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { RenderElementProps } from 'slate-react';
import * as React from 'react';

const IELTSCalculatorNodeReadOnly = dynamicEditorComponent<{ id: string; isPreview: boolean }>(() =>
  import(/* webpackExports: "IELTSCalculatorNodeReadOnly" */ './IELTSCalculatorNode').then(
    (mod) => mod.IELTSCalculatorNodeReadOnly
  )
);

export const IELTSCalculatorReadOnlyPlugin = (): SlatePlugin => {
  return {
    renderElement: (props: RenderElementProps) => {
      const { element } = props;
      if (element.type === MediaType.CALCULATOR) {
        return <IELTSCalculatorNodeReadOnly id={element.id as string} />;
      }
      return null;
    },
    voidTypes: [MediaType.CALCULATOR],
  };
};
